module.exports = __webpack_public_path__ + "img/setup-test-step-3-mobile.a156eacb.png";